import {
  Box,
  MenuItem,
  Select,
  Typography,
  useMediaQuery,
  useTheme,
  Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid2";
import ProgressBar from "./ProgressBar";
import TopPerformers from "./TopPerformers";
import ImprovementAreas from "./Improvement";
import Achievements from "./Achievements";
import TeamRanking from "./TeamRanking";
import axiosInstance from "../../../services/axiosInterceptors";
import apiEndPointsConfig from "../../../services/apiEndPoints";
import { jwtDecode } from "jwt-decode";
import CommonFilter from "../../../components/CommonFilter";
import Loader from "../../../components/AnimatedLoader";
import ParentWrapper from "../../../components/ParentWrapper";
import Header from "../../../components/header";

function LeaderBoardHome() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [timeFilter, setTimeFilter] = useState("This Week");
  const [responseData, setResponseData] = useState();
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : "";
  const timeFilterOptions = ["This Week", "This Month"];
  const [payloadData, setPayloadData] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLeaderBoardDetails();
  }, [payloadData]);

  const fetchLeaderBoardDetails = async () => {
    const today = new Date();
    const data = {
      startDate: payloadData?.filters?.startDate
        ? payloadData?.filters?.startDate
        : today?.toISOString().split("T")[0],
      endDate: payloadData?.filters?.endDate
        ? payloadData?.filters?.endDate
        : today?.toISOString().split("T")[0],
    };
    try {
      const res = await axiosInstance.post(
        apiEndPointsConfig?.agentLeaderboard,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setResponseData(res?.data?.data);
      setLoading(false);
    } catch (error) {
      const statusCode = error?.response?.data?.status?.code;
      if (statusCode === 401) {
        localStorage.clear();
      } else {
        console.error("Leaderboard fetch error:", error);
      }
    }
  };

  const isCurrentAgent = responseData?.performanceLeaderborad?.find(
    (agent) => agent?.agentId === decodedToken?.agentId
  );

  const isFilter = { date: true, filter: false };

  return (
    // <Box
    //   sx={{
    //    ml: {
    //       xs: "0px",
    //       md: "230px",
    //     },
    //     p: 3,
    //     display: "flex",
    //     flexDirection: "column",
    //     gap: 2,
    //   }}
    // >
    //   {loading ? (
    //     <Loader />
    //   ) : (
    //     <Grid container spacing={2.5} sx={{}}>
    //       <Grid item size={{ xs: 12 }} sx={{}}>
    //         <Box
    //           sx={{
    //             display: "flex",
    //             justifyContent: "space-between",
    //             alignItems: "flex-start",
    //             flexDirection: isMobile ? "column" : "row",
    //             mb: 3,
    //           }}
    //         >
    //           <Box>
    //             <Typography
    //               variant="h5"
    //               sx={{
    //                 fontFamily:
    //                   "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
    //                 fontWeight: 700,
    //               }}
    //               gutterBottom
    //             >
    //               LeaderBoard
    //             </Typography>
    //             <Typography variant="subtitle1" color="text.secondary">
    //               See how your performance compares with your teammates
    //             </Typography>
    //           </Box>
    //           <Box
    //             sx={{
    //               display: "flex",
    //               gap: 2,
    //               alignSelf: isMobile ? "flex-end" : "center",
    //             }}
    //           >
    //             <CommonFilter
    //               setPayloadData={setPayloadData}
    //               storageName={"AgentleaderBoard"}
    //               isFilter={isFilter}
    //             />
    //           </Box>
    //         </Box>
    //       </Grid>
    //       <Grid
    //         item
    //         size={{ xs: 12, sm: 12, md: 8 }}
    //         sx={{ display: "flex", flexDirection: "column" }}
    //       >
    //         <TopPerformers
    //           leaderBoardData={responseData?.performanceLeaderborad}
    //         />
    //       </Grid>
    //       <Grid
    //         item
    //         size={{ xs: 12, sm: 12, md: 4 }}
    //         sx={{ display: "flex", flexDirection: "column" }}
    //       >
    //         <ProgressBar
    //           isCurrentAgent={isCurrentAgent}
    //           responseData={responseData}
    //         />
    //       </Grid>
    //       <Grid item size={{ xs: 8 }}>
    //         <Grid container spacing={2.5}>
    //           <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{}}>
    //             <TeamRanking
    //               leaderBoardData={responseData?.performanceLeaderborad}
    //               isCurrentAgent={isCurrentAgent}
    //             />
    //           </Grid>

    //           <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{}}></Grid>
    //         </Grid>
    //       </Grid>
    //       <Grid item size={{ xs: 4 }}>
    //         <Grid container spacing={2.5}>
    //           <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{}}>
    //             <ImprovementAreas
    //               isCurrentAgent={isCurrentAgent}
    //               responseData={responseData}
    //             />
    //           </Grid>
    //           <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{}}>
    //             <Achievements leaderBoardData={responseData?.achievements} />
    //           </Grid>
    //         </Grid>
    //       </Grid>
    //     </Grid>
    //   )}
    // </Box>

    <ParentWrapper>
      {loading ? (
        <Loader />
      ) : (
        <Grid container spacing={2.5} sx={{}}>
          <Grid item size={{ xs: 12 }} sx={{}}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "flex-start",
                flexDirection: isMobile ? "column" : "row",
                mb: 3,
              }}
            >
              <Box>
                {/* <Typography
                  variant="h5"
                  sx={{
                    fontFamily:
                      "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    fontWeight: 700,
                  }}
                  gutterBottom
                >
                  LeaderBoard
                </Typography>
                <Typography variant="subtitle1" color="text.secondary">
                  See how your performance compares with your teammates
                </Typography> */}
                <Header
                  title={"LeaderBoard"}
                  subHeading={
                    "See how your performance compares with your teammates"
                  }
                />
              </Box>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  alignSelf: isMobile ? "flex-end" : "center",
                }}
              >
                <CommonFilter
                  setPayloadData={setPayloadData}
                  storageName={"AgentleaderBoard"}
                  isFilter={isFilter}
                />
              </Box>
            </Box>
          </Grid>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 8 }}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <TopPerformers
              leaderBoardData={responseData?.performanceLeaderborad}
            />
          </Grid>
          <Grid
            item
            size={{ xs: 12, sm: 12, md: 4 }}
            sx={{ display: "flex", flexDirection: "column" }}
          >
            <ProgressBar
              isCurrentAgent={isCurrentAgent}
              responseData={responseData}
            />
          </Grid>
          <Grid item size={{ xs: 8 }}>
            <Grid container spacing={2.5}>
              <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{}}>
                <TeamRanking
                  leaderBoardData={responseData?.performanceLeaderborad}
                  isCurrentAgent={isCurrentAgent}
                />
              </Grid>

              <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{}}></Grid>
            </Grid>
          </Grid>
          <Grid item size={{ xs: 4 }}>
            <Grid container spacing={2.5}>
              <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{}}>
                <ImprovementAreas
                  isCurrentAgent={isCurrentAgent}
                  responseData={responseData}
                />
              </Grid>
              <Grid item size={{ xs: 12, sm: 12, md: 12 }} sx={{}}>
                <Achievements leaderBoardData={responseData?.achievements} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
    </ParentWrapper>
  );
}

export default LeaderBoardHome;
